import {
  GET_SERVICE_TYPE,
  INSERT_SERVICE_TYPE,
  UPDATE_SERVICE_TYPE,
  DELETE_SERVICE_TYPE,
  FULFILLED,
  REJECTED,
  PENDING
} from "../utils/types";
const initialState = {
  data: {},
  getError: false,
  updateError: false,
  deleteError: false,
  insertError: false,
  getLoading: false,
  updateLoading: false,
  deleteLoading: false,
  insertLoading: false
};

export default function serviceTypeReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    // GET
    case `${GET_SERVICE_TYPE + PENDING}`:
      return { ...state, getError: false, getLoading: true };
    case `${GET_SERVICE_TYPE + FULFILLED}`:
      return { ...state, data: payload, getError: false, getLoading: false };
    case `${GET_SERVICE_TYPE + REJECTED}`:
      return { ...state, getError: true, getLoading: false, data: {} };
    // UPDATE
    case `${UPDATE_SERVICE_TYPE + PENDING}`:
      return { ...state, updateError: false, updateLoading: true };
    case `${UPDATE_SERVICE_TYPE + FULFILLED}`:
      return {
        ...state,
        data: payload,
        updateError: false,
        updateLoading: false
      };
    case `${UPDATE_SERVICE_TYPE + REJECTED}`:
      return { ...state, updateError: true, updateLoading: false };
    // DELETE
    case `${DELETE_SERVICE_TYPE + PENDING}`:
      return { ...state, deleteError: false, deleteLoading: true };
    case `${DELETE_SERVICE_TYPE + FULFILLED}`:
      return {
        ...state,
        data: payload,
        deleteError: false,
        deleteLoading: false
      };
    case `${DELETE_SERVICE_TYPE + REJECTED}`:
      return { ...state, deleteError: true, deleteLoading: false};
    // INSERT
    case `${INSERT_SERVICE_TYPE + PENDING}`:
      return { ...state, insertError: false, insertLoading: true };
    case `${INSERT_SERVICE_TYPE + FULFILLED}`:
      return {
        ...state,
        data: payload,
        insertError: false,
        insertLoading: false
      };
    case `${INSERT_SERVICE_TYPE + REJECTED}`:
      return { ...state, insertError: true, insertLoading: false};
    default:
      return state;
  }
}
